import "./App.css";
import * as handTrack from "handtrackjs";
import Stepper from "./screens/GameStepper/GameStepper";
import useStore from "./store/store";
import { Routes, Route, Link } from "react-router-dom";
import Home from "./screens/Home";
import PlayerRegister from "./screens/PlayerRegister";
import NotFound from "./screens/NotFound";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import End from "./screens/End/End";
import right from "./assets/right.png";
import top from "./assets/top.png";
import left from "./assets/left.png";
import bottom from "./assets/bottom.png";
import {useEffect} from 'react'

const modelParams = {
  flipHorizontal: true, // flip e.g for video
  imageScaleFactor: 0.7, // reduce input image size for gains in speed.
  maxNumBoxes: 1, // maximum number of boxes to detect
  iouThreshold: 0.5, // ioU threshold for non-max suppression
  scoreThreshold: 0.6, // confidence threshold for predictions.
};

function App() {
  const { setModel, model, detector } = useStore();
  useEffect(() => {
    // attempt to cache
    const imgR = new Image();
    const imgT = new Image();
    const imgB = new Image();
    const imgL = new Image();
    imgR.src = right;
    imgL.src = left;
    imgB.src = bottom;
    imgT.src = top;
  }, [])

  if (!model) {
    handTrack.load(modelParams).then((lmodel) => {
      // detect objects in the image.
      console.info("Loaded =>  face models");
      setModel(lmodel);
    });
  }

  if (!model) {
    return (
      // <div className="absolute top-0 bottom-0 left-0 right-0 bg-slate-600 flex flex-col content-center justify-center">
      <div className="flex justify-center items-center h-full w-full">
        <div role="status">
          <svg
            className="inline mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-yellow-400"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      </div>
      // </div>
    );
  }

  return (
    <div className="flex flex-col h-full w-full max-h-full max-w-full overflow-x-hidden justify-center items-center content-center font-poppins">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="register" element={<PlayerRegister />} />
        <Route path="game" element={<Stepper model={model} detector={detector} />} />
        <Route path="end" element={<End />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ToastContainer />
    </div>
  );
}

export default App;
